import { OverlayTrigger, Popover } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import Badge from "components/atoms/Badge/Badge";
import { QuoteStatusColors } from "constants/";

type OtherStatusProps = {
  statusArr: {
    value: string;
    label: string;
  }[];
};

function OtherStatus({ statusArr }: OtherStatusProps) {
  return (
    <div>
      <OverlayTrigger
        trigger={["hover", "focus"]}
        placement="top"
        rootClose
        overlay={
          <Popover id="popover-basic" className="mb-3">
            <Popover.Content>
              <div className="font-weight-bold my-2 d-flex justify-content-center">
                <FormattedMessage id="components.molecules.navigation.otherStatus" defaultMessage="Other Status" />
              </div>

              {statusArr.slice(1).map(({ value, label }) => (
                <div key={value} className="mb-2">
                  <Badge type={QuoteStatusColors[value] || "secondary"} label={label} />
                </div>
              ))}
            </Popover.Content>
          </Popover>
        }
      >
        <div className="ml-2">+{statusArr.length - 1}</div>
      </OverlayTrigger>
    </div>
  );
}

export default OtherStatus;
